module.exports = __webpack_public_path__ + "static/media/microfinance.f6bd35d5.jpg";